import type { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import type { FloatingLabelInputProps } from "@aviary";
import { FloatingLabelInput } from "@aviary";
import { IsNameValid } from "@unauthenticated/shared/components/NameValidation";
import { l } from "@unauthenticated/shared/locales/i18n";

interface Props extends Omit<FloatingLabelInputProps, "id" | "label" | "type"> {
  errors?: ReactNode[];
  isDirty?: boolean;
  value: string;
}

const DispensaryNameInput: FC<Props> = ({ isDirty, errors, value, ...rest }) => {
  const { t } = useTranslation();

  const getErrors = () => {
    if (!isDirty || !value) return null;

    if (value.length < 4) return [...errors, t(l.common.DispensaryNameTooShort)];

    if (IsNameValid(value)) return null;

    return [...errors, t(l.common.DispensaryNameInvalid)];
  };

  const renderInput = () => (
    <FloatingLabelInput
      id="dispensaryName"
      type="text"
      name="dispensaryName"
      data-e2e="dispensary_name"
      label={t(l.common.DispensaryName)}
      errors={getErrors()}
      disabled={false}
      value={value}
      {...rest}
    />
  );

  return renderInput();
};

DispensaryNameInput.defaultProps = {
  errors: [],
};

export { DispensaryNameInput };
